module.exports = __webpack_public_path__ + "static/media/login.47489c3c.svg";